import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { tasksQueueFeature } from 'src/app/tasks-queue/store/tasks-queue.feature';

@NgModule({
  imports: [
    StoreModule.forFeature(tasksQueueFeature),
  ],
  exports: [],
  declarations: [],
  providers: [],
})
export class TasksQueueStoreModule {
}
